export default __webpack_public_path__ + "static/media/wegovy-inject-remove-needle.3ca47243.mp4";